import React, { useEffect, useState } from 'react';
import CardUi from '../components/common/Card';
import ConnectingAirportsIcon from "@mui/icons-material/ConnectingAirports";
import {Link} from "react-router-dom";
import FlightTakeoffIcon from '@mui/icons-material/FlightTakeoff';
import LocationCityIcon from '@mui/icons-material/LocationCity';
import PublicIcon from '@mui/icons-material/Public';
import {Divider} from "antd";




const AllMyFlights: React.FC = () => {
  const [items, setItems] = useState([
    <div>
      <ConnectingAirportsIcon/>
      <Link to="/flightsnapshot">  Competitive snapshot by Flights</Link>
    </div>,
    <div>
      <FlightTakeoffIcon/>
      <Link to="/airportsnapshot">  Competitive snapshot by Airport</Link>
    </div>,
    <div>
      <LocationCityIcon/>
      <Link to="/citysnapshot">  Competitive snapshot by Destination city</Link>
    </div>,
    <div>
      <PublicIcon/>
      <Link to="/countrysnapshot">  Competitive snapshot by Destination country</Link>
    </div>
  ]);

  const items2 = [
    'My flights found at competitors',
    'Competitive snapshot by Flight',
  ];

  const items3 = [
    'Unmet flights by Airport',
    'Unmet flights by Destination country',
    'Unmet flights by Destination city',
  ];

  useEffect(() => {
  }, []);

  return (
      <>
        <Divider style={{marginBottom:0}}>
          <h3 style={{ fontSize: '30px', fontWeight: 'bold', fontFamily: 'Arial, sans-serif', color: 'rgb(3 55 120)', letterSpacing: '0.5px' }}>Flights pricing analysis</h3>
        </Divider>
    <div
      style={{
        margin: '60px auto',
        display: 'flex',
        gap: '3rem',
        flexDirection: 'column',
      }}
    >

      <div>
        <CardUi
          items={items}
          // title="Create new customize tabular reports by filtering, segmenting and organizing the data views"
          title="Choose one of tabular reports by Airports/destinations/continents"

        />
      </div>
      <div>
        <CardUi
          items={items2}
          title="Competitive snapshots"

        />
      </div>
    </div>
  </>);
};

export default AllMyFlights;
